import React from "react";

const Chapter6 = () => {
  return (
    <>
      <h2>When are most CECs present in the South Platte River?</h2>
      <p>
        Our monitoring results show that CECs are consistently present in our
        urban waterways. High flows from Spring runoff or storm events will
        actually initially increase the loading of CECs into our waterways and
        later provide the dilution effect. In low flow conditions, many of the
        Denver Metro area streams are effluent (discharge) dominated so CECs
        persist.
      </p>
    </>
  );
};

export default Chapter6;
